import React from "react";
import images from "../../../images";
import NotificationBadge from "../../../components/common/NotificationBadge/NotificationBadge";

const ProfileChevron = ({
  title,
  onClick,
  isShowNotificationBadge = false,
  unreadCount = 0,
}) => {
  return (
    <div
      onClick={onClick}
      className="flex flex-row items-center justify-between min-h-[55px] xs:min-h-[70px] w-full text-[12px] xs:text-sm font-medium tracking-tight text-[#333333] rounded-none border-b first:border-t border-[#E9E6E4] border-solid cursor-pointer"
    >
      <span className="text-[16px] xs:text-xl text-[#333] font-medium flex items-center gap-2">
        {title}
        {isShowNotificationBadge && unreadCount > 0 && (
          <NotificationBadge count={unreadCount} />
        )}
      </span>
      <img src={images.ChevronRightIcon} alt="" className="w-2" />
    </div>
  );
};

export default ProfileChevron;
